import React, { useMemo } from 'react';
import DefaultExceptionForm from './Form';
import { Button } from '@material-ui/core';

const DefaultExceptionFlow = ({
  classes,
  DispatchStore,
  editInfo,
  onChange,
  shipmentPieces,
  isDeliveryException,
  handleAddException,
  handleRemoveException,
  isMultipleExceptionsEnabled
}) => {
  const exceptionTypeOptions = DispatchStore.exceptions || [];
  const packageTypeList = DispatchStore.packageCodes || [];

  const exceptions = useMemo(() => editInfo.exception || [], [editInfo.exception]);
  const selectedExceptionCodes = useMemo(
    () => exceptions.map((exception) => exception.code),
    [exceptions]
  );

  return (
    <div>
      {exceptions?.map((exception, index) => (
        <DefaultExceptionForm
          key={index}
          index={index}
          classes={classes}
          exception={exception}
          onChange={onChange(index)}
          packageTypeList={packageTypeList}
          exceptionTypeOptions={exceptionTypeOptions}
          selectedExceptionCodes={selectedExceptionCodes}
          shipmentPieces={shipmentPieces}
          totalExceptionsCount={exceptions?.length || 0}
          isDeliveryException={isDeliveryException}
          handleRemoveException={handleRemoveException}
          isMultipleExceptionsEnabled={isMultipleExceptionsEnabled}
        />
      ))}
      {isMultipleExceptionsEnabled && (
        <Button variant="text" color="primary" onClick={handleAddException}>
          + Add Exception
        </Button>
      )}
    </div>
  );
};

export default DefaultExceptionFlow;
